import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { saveAs } from "file-saver";

import DownloadIcon from "@mui/icons-material/Download";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

function getBool(val) {
   if (val) {
      return !!JSON.parse(String(val).toLowerCase());
   }
}

export default function DataGridContainer({
   data,
   height,
   type,
   disableColumnFilter,
   load,
   callback,
   preview,
   updateColors,
}) {
   let columns;
   let initialState;

   const toggleColor = (decklistId, colors, color) => {
      const newColors = colors.includes(color) ? colors.filter((c) => c !== color) : [...colors, color];
      updateColors(decklistId, newColors);
   };

   columns = [
      {
         field: "id",
         headerName: "Decklist Id",
         editable: false,
         width: 100,
         filterable: false,
      },
      {
         field: "Format",
         headerName: "Format",
         editable: false,
         width: 120,
      },
      {
         field: "LastName",
         headerName: "Last Name",
         editable: false,
         width: 180,
      },
      {
         field: "FirstName",
         headerName: "First Name",
         editable: false,
         width: 150,
      },
      {
         field: "Archetype",
         headerName: "Archetype",
         editable: false,
         width: 350,
         renderCell: (params) => (
            <>
               <Stack direction='row' spacing={0.5}>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("W")) ? 1 : 0.1,
                        cursor: "pointer",
                     }}
                     onClick={() => toggleColor(params.row.id, JSON.parse(params.row.Colors), "W")}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/white.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("U")) ? 1 : 0.1,
                        cursor: "pointer",
                     }}
                     onClick={() => toggleColor(params.row.id, JSON.parse(params.row.Colors), "U")}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/blue.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("B")) ? 1 : 0.1,
                        cursor: "pointer",
                     }}
                     onClick={() => toggleColor(params.row.id, JSON.parse(params.row.Colors), "B")}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/black.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("R")) ? 1 : 0.1,
                        cursor: "pointer",
                     }}
                     onClick={() => toggleColor(params.row.id, JSON.parse(params.row.Colors), "R")}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/red.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("G")) ? 1 : 0.1,
                        cursor: "pointer",
                     }}
                     onClick={() => toggleColor(params.row.id, JSON.parse(params.row.Colors), "G")}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/green.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("C")) ? 1 : 0.1,
                        cursor: "pointer",
                     }}
                     onClick={() => toggleColor(params.row.id, JSON.parse(params.row.Colors), "C")}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/colorless.png"}
                        width='100%'
                     />
                  </Box>
                  {!params.value && <Box sx={{ pl: 2 }}>None</Box>}
                  {params.value && <Box sx={{ pl: 2 }}>{params.value}</Box>}
               </Stack>
            </>
         ),
      },
      {
         field: "PreviewDecklist",
         headerName: "Constructed",
         editable: false,
         width: 270,
         filterable: false,
         sortable: false,
         renderCell: (params) => (
            <>
               <Button
                  size='small'
                  onClick={() => load(1, params.row.id, "")}
                  sx={{ mr: 1 }}
               >
                  LOAD 1
               </Button>
               <Button
                  size='small'
                  onClick={() => load(2, params.row.id, "")}
                  sx={{ mr: 1 }}
                  color='warning'
               >
                  LOAD 2
               </Button>
               <Button
                  size='small'
                  onClick={() => load(3, params.row.id, "")}
                  sx={{ mr: 1 }}
                  color='error'
               >
                  LOAD 3
               </Button>
            </>
         ),
      },
      {
         field: "PreviewDecklist2",
         headerName: "Draft",
         editable: false,
         width: 270,
         filterable: false,
         sortable: false,
         renderCell: (params) => (
            <>
               <Button
                  size='small'
                  onClick={() => load(1, params.row.id, "Draft")}
               >
                  LOAD 1
               </Button>
               <Button
                  size='small'
                  onClick={() => load(2, params.row.id, "Draft")}
                  color='warning'
               >
                  LOAD 2
               </Button>
               <Button
                  size='small'
                  onClick={() => load(3, params.row.id, "Draft")}
                  color='error'
               >
                  LOAD 3
               </Button>
            </>
         ),
      },
      {
         field: "CardsSum",
         headerName: "Cards",
         editable: false,
         width: 60,
         filterable: false,
         sortable: false,
      },
      {
         field: "LandsSum",
         headerName: "Lands",
         editable: false,
         width: 60,
         filterable: false,
         renderCell: (params) => {
            const counts = JSON.parse(params.row.MainDeckCount);
            if (counts.Land) {
               return counts.Land;
            }
            return 0;
         },
         sortable: false,
      },
      {
         field: "SideboardSum",
         headerName: "Sideboard Sum",
         editable: false,
         width: 60,
         filterable: false,
         sortable: false,
      },
      {
         field: "Colors",
         headerName: "Colors",
         editable: false,
         width: 100,
         filterable: false,
         valueFormatter: (value) => (JSON.parse(value.value).join("")),
      },
   ];

   initialState = {
      sorting: {
         sortModel: [{ field: "LastName", sort: "asc" }],
      },
      columns: {
         columnVisibilityModel: {
            id: false,
            CardsSum: true,
            LandsSum: true,
            SideboardSum: true,
            // Colors: false,
         },
      },
   };

   const handleCallback = (e) => {
      callback(e.target.id, e.target.value);
   };

   const handlePreview = (e) => {
      preview(e.target.id);
   };

   const handleDownload = (e) => {
      saveAs(SERVER_URL + "/cardimages/png/" + e.target.value, e.target.value);
   };

   return (
      <>
         <Box sx={{ height: height ? height : 400, width: "100%" }}>
            <DataGrid
               initialState={initialState}
               sx={{ backgroundColor: "#efefef" }}
               rows={data}
               rowHeight={
                  type === "cardOverview" || type === "cardOverlay" ? 120 : 40
               }
               disableColumnFilter={disableColumnFilter}
               columns={columns}
               rowsPerPageOptions={[100, 200, 300, 1000, 5000]}
               components={{ Toolbar: GridToolbar }}
               componentsProps={{
                  toolbar: {
                     printOptions: {
                        disableToolbarButton: true,
                     },
                  },
               }}
               disableSelectionOnClick
            />
         </Box>
      </>
   );
}
